import { useEffect, useState } from "react"

import { useLazyGetOrderProductsQuery } from "store/api/widgetsApi"

import { getDateRangeFromOption } from "utils/dateUtils"
import { HalfDoughnutSummaryWidget } from "components/widgets/HalfDoughnutSummaryWidget"
import { allDateSelectOptions } from "pages/vendor/Dashboard/constants"

const CHART_COLORS = {
  nuveThermostats: "#3b82f6",
  cWireAdapters: "#7c3aed",
} as const

const initialState = {
  total: 0,
  thermostat: 0,
  cwa: 0,
}

export const WidgetDevicesOrderedByType = () => {
  const [selectedDateRange, setSelectedDateRange] = useState(() =>
    getDateRangeFromOption(String(allDateSelectOptions[0].value)),
  )
  const [triggerGetOrderProducts, { isFetching }] = useLazyGetOrderProductsQuery()
  const [widgetData, setWidgetData] = useState(initialState)

  useEffect(() => {
    const fetchData = async () => {
      const res = await triggerGetOrderProducts({
        date_start: selectedDateRange[0],
        date_end: selectedDateRange[1],
      })
      if (res?.data?.data) {
        setWidgetData({
          total: res.data.data.total ?? 0,
          thermostat: res.data.data.thermostat ?? 0,
          cwa: res.data.data.cwa ?? 0,
        })
      }
    }

    fetchData()
  }, [selectedDateRange, triggerGetOrderProducts])

  return (
    <HalfDoughnutSummaryWidget
      title="Devices Ordered by Type"
      mainLabel="Devices ordered"
      chartOptions={{ cutout: "65%" }}
      isFetching={isFetching}
      dateSelectOptions={allDateSelectOptions}
      minDate="2025-05-27"
      onSelectDateRange={setSelectedDateRange}
      defaultSelectedDateOption={allDateSelectOptions[0]}
      items={[
        { label: "Nuve Thermostats", color: CHART_COLORS.nuveThermostats, value: widgetData.thermostat },
        { label: "C Wire Adapters (CWA)", color: CHART_COLORS.cWireAdapters, value: widgetData.cwa },
      ]}
    />
  )
}
